<template>
  <div class="mall-malls wrap">
    <h2>Types of shopping malls<br>we can develop</h2>
    <p class="sub-title">
      制作可能なショッピングモール
    </p>

    <div class="img-cover">
      <img alt="楽天市場" src="@/assets/common/syukyaku-kyoutu-logo001.png" />
      <img alt="Amazon" src="@/assets/common/syukyaku-kyoutu-logo002.png" />
      <img alt="Yahoo" src="@/assets/common/syukyaku-kyoutu-logo003.png" />
      <img
        alt="Aupayマーケット"
        src="@/assets/common/syukyaku-kyoutu-logo004.png"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "mall-malls",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 20px;
  color: var(--main);
  margin: 50px 0 10px 0;
}
.note {
  text-align: right;
}
.img-cover {
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    // flex-direction: column;
    flex-wrap: wrap;
  }
}
img {
  width: 23%;
  @media screen and (max-width: 767px) {
    width: 48%;
    margin-bottom: 20px;
  }
}
.des {
  margin-top: 50px;
}
</style>
